export default "__VITE_PUBLIC_ASSET__6456bf40__"